(function () {
  'use strict';

  function initSticky() {
    var sticky = document.querySelector('[data-landing-sticky]');
    var heroBuyBtn = document.querySelector('.landing-kit__buy .mfs-btn--primary');
    if (!sticky || !heroBuyBtn) return;

    var show = function () {
      sticky.classList.add('is-visible');
      sticky.setAttribute('aria-hidden', 'false');
    };
    var hide = function () {
      sticky.classList.remove('is-visible');
      sticky.setAttribute('aria-hidden', 'true');
    };

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) hide(); else show();
        });
      }, { threshold: 0, rootMargin: '0px 0px -10% 0px' });
      observer.observe(heroBuyBtn);
    } else {
      window.addEventListener('scroll', function () {
        if (window.scrollY > 600) show(); else hide();
      }, { passive: true });
    }
  }

  function initThumbs() {
    var thumbs = Array.prototype.slice.call(document.querySelectorAll('[data-landing-thumb]'));
    var mainImg = document.querySelector('[data-landing-main-img]');
    if (!thumbs.length || !mainImg) return;

    var counter = document.querySelector('[data-landing-counter]');
    var gallery = document.querySelector('[data-landing-gallery]');
    var current = 0;

    function activate(index) {
      if (index < 0 || index >= thumbs.length || index === current) return;
      var thumb = thumbs[index];
      var src = thumb.getAttribute('data-src');
      if (!src) return;
      mainImg.removeAttribute('srcset');
      mainImg.removeAttribute('sizes');
      mainImg.setAttribute('src', src);
      mainImg.setAttribute('alt', thumb.getAttribute('data-alt') || '');
      thumbs.forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
      current = index;
      if (counter) counter.textContent = String(index + 1);
    }

    thumbs.forEach(function (thumb, index) {
      thumb.addEventListener('click', function () { activate(index); });
    });

    // Balayage tactile sur la photo principale — le compteur annonce qu'il y
    // a plusieurs visuels, le swipe permet d'y aller sans viser une vignette.
    if (gallery && thumbs.length > 1) {
      var startX = 0, startY = 0, tracking = false;
      gallery.addEventListener('touchstart', function (e) {
        if (e.touches.length !== 1) { tracking = false; return; }
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
        tracking = true;
      }, { passive: true });
      gallery.addEventListener('touchend', function (e) {
        if (!tracking) return;
        tracking = false;
        var touch = e.changedTouches[0];
        var dx = touch.clientX - startX;
        var dy = touch.clientY - startY;
        // On ignore les gestes majoritairement verticaux : c'est du scroll.
        if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
        activate(dx < 0 ? current + 1 : current - 1);
      }, { passive: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initSticky();
      initThumbs();
    });
  } else {
    initSticky();
    initThumbs();
  }
})();
